import React, { useState, useEffect } from "react";
import Avatar from "@mui/material/Avatar";
// import Button from "@mui/material/Button";
// import TextField from "@mui/material/TextField";
// import Link from "@mui/material/Link";
// import Grid from "@mui/material/Grid";
import { useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import { AccountMenu } from "./Component/AccountMenu";
import CircularProgress from "@mui/material/CircularProgress";
import { API_DOMAIN_URL } from "./Common";

export function ValidateMainMember() {
  const [validateStatus, setValidateStatus] = useState(0);
  let { UserName, Token } = useParams();
  //console.log("UserName: " + UserName.toString());
  //console.log("Token: " + Token.toString());

  useEffect(() => {
    const code = process.env.REACT_APP_API_CODE;
    let url =
      API_DOMAIN_URL +
      `/api/ValidateUser?code=${code}&UserName=${UserName}&Token=${Token}`;
    //console.log(url);
    fetch(url)
      .then((response) => {
        if (response.status == 200) {
          setValidateStatus(1);
        } else {
          if (validateStatus != 1) {
            setValidateStatus(2);
          }
        }
      })
      .catch(() => {
        console.error();
      });
  });

  const validatingBox = (
    <Box sx={{ mt: 1 }}>
      <Typography variant="body2" color="error">
        メンバー有効化中
      </Typography>
      <CircularProgress />
    </Box>
  );

  const validatedBox = (
    <Box sx={{ mt: 1 }}>
      <Typography variant="h5" color="success">
        メンバー有効化完了
      </Typography>
      <Typography variant="body2">
        アプリに戻ってログインしてください。
      </Typography>
    </Box>
  );

  const failedValidateBox = (
    <Box sx={{ mt: 1 }}>
      <Typography variant="h5" color="success">
        メンバー有効化失敗
      </Typography>
      <Typography variant="body2">
        アプリに戻ってサインアップからやり直してください
      </Typography>
    </Box>
  );

  const getDisplay = (status) => {
    if (status == 0) {
      return validatingBox;
    } else if (status == 1) {
      return validatedBox;
    } else if (status == 2) {
      return failedValidateBox;
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <AccountMenu />
      <Avatar sx={{ m: 1, bgcolor: "#d33320" }}>
        <LockOutlinedIcon />
      </Avatar>

      {getDisplay(validateStatus)}
    </Box>
  );
}
